import { render, staticRenderFns } from "./test-custom.vue?vue&type=template&id=691b2b4f"
import script from "./test-custom.vue?vue&type=script&lang=js"
export * from "./test-custom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports